export class CreateAddressTypeModel {
  public descricao = ''
}

export class EditAddressTypeModel {
  public id = 0
  public descricao = ''
}

export class DeleteAddressTypeModel {
  public id = 0
  public descricao = ''
}

export class SearchAddressTypeModel {
  public descricao = ''
}

export class CreateAddressTypeResponse {
  public response: any
}
export class EditAddressTypeResponse {
  public response: any
}
export class DeleteAddressTypeResponse {
  public response: any
}
export class PagedAddressTypeResponse {
  public response: any
}
